import WidgetsIcon from '@material-ui/icons/Widgets';
import { Route, Switch } from 'react-router-dom';
import { ListItemLink } from '../../../components/sidebar-list-item-link';
import TimelineIcon from '@material-ui/icons/Timeline';
import HistoryIcon from '@material-ui/icons/History';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';
import PasswordIcon from '@mui/icons-material/Password';
import RiderDashboard from './dashboard/index';
import Parcel from './parcel/index';
import History from './history/index';
import PickupRequest from './pickupRequest/index';
import ChangePassword from '../merchant/change_password/index';

const routeList: Array<{ to: string; component?: any; icon?: any; primary: string }> = [
  { to: '/dashboard', primary: 'Dashboard', icon: TimelineIcon, component: RiderDashboard },
  { to: '/dashboard/parcel', primary: 'Parcels', icon: WidgetsIcon, component: Parcel },
  { to: '/dashboard/history', primary: 'History', icon: HistoryIcon, component: History },
  { to: '/dashboard/pickup-request', primary: 'Pickup Request', icon: LocalShippingIcon, component: PickupRequest },
  { to: '/dashboard/change_password', primary: 'Change Password', icon: PasswordIcon, component: ChangePassword },
];

export const sidebar = (
  <div>
    {routeList
      .filter((item) => item.icon)
      .map((item, index) => (
        <ListItemLink key={index} to={item.to} primary={item.primary} icon={item.icon} />
      ))}
  </div>
);

export const routeContainer = () => (
  <Switch>
    {routeList
      .filter((item) => item.component)
      .map((item, index) => (
        <Route key={index} exact path={item.to} component={item.component} />
      ))}
  </Switch>
);
